import { useEffect, useContext } from 'react';
import { observer } from 'mobx-react';
import { ToastContainer } from 'react-toastify';
import cn from 'classnames';
import CancelationModal from './components/CancelationModal';
import { Modal } from 'uiKit/organisms/Modal';
import LimitationLiabilityModal from './components/LimitationLiabilityModal';
import Spinner from './components/Spinner';
import Router from './Router';
import { preventBodyScroll } from './utils';
import { useStores } from './stores';
import { AuthContext } from 'context/AuthContext';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  const { isAuthenticated } = useContext(AuthContext);

  const {
    modalStore: { isOpen: isModalOpen, modalName, hideModal },
    userStore: { loginUserWinAuth },
    themeStore,
  } = useStores();

  useEffect(() => {
    if (isAuthenticated) {
      loginUserWinAuth();
    }
  }, [loginUserWinAuth, isAuthenticated]);

  const mainThemeClassName =
    themeStore.themeMode === 'classic'
      ? 'classic-theme'
      : themeStore.themeMode === 'dark'
      ? 'dark-scheme'
      : 'light-scheme';

  const modalMap: Record<string, React.ComponentType> = {
    LimitationLiabilityModal,
    CancelationModal,
    DeleteModal: CancelationModal,
    CancelSubscriptionModal: CancelationModal,
  };

  const ComponentModal = modalMap[modalName];

  useEffect(() => {
    if (isModalOpen) {
      preventBodyScroll('add');
    } else {
      preventBodyScroll.reset();
    }
  }, [isModalOpen]);

  return (
    <div className={cn(mainThemeClassName, 'bns3_app_wrapper')} id="bns3-app-wrapper">
      <Spinner />

      <Router />

      <ToastContainer
        autoClose={5000}
        position="top-right"
        hideProgressBar
        newestOnTop
        closeOnClick
        draggable
        pauseOnHover
        style={{ top: '4.5rem', right: '1.65rem' }}
        theme="light"
      />

      <Modal onClose={hideModal} open={isModalOpen}>
        {ComponentModal && <ComponentModal />}
      </Modal>
    </div>
  );
};

export default observer(App);
